var React = require('react');
var labels = require('MemberJoinLabels');

class ProgressBar extends React.Component {
    constructor(props) {
        super(props);

        this.getStepClassName = this.getStepClassName.bind(this);
        this.jumpToStep = this.jumpToStep.bind(this);
        this.stepIsClickable = this.stepIsClickable.bind(this);
    }

    getStepClassName(step) {
        if (this.props.appState.applicationCreated && step < 3) {
            return 'disabled';
        }

        if (this.props.appState.currentStep === step) {
            return 'active';
        }

        if (this.props.appState.stepProgress >= step) {
            return '';
        }

        return 'disabled';
    }

    jumpToStep(event, step) {
        event.preventDefault();

        if (this.stepIsClickable(step) || this.props.appState.debugMode) {
            this.props.goToStep(event, step);
        }
    }

    stepIsClickable(step) {
        if (this.props.appState.applicationCreated && step < 3) {
            return false;
        }

        return this.props.appState.currentStep !== step && this.props.appState.stepProgress >= step;
    }

    render() {
        return <ul className={"progress-bar"}>
            <a href="#" className={this.getStepClassName(1)} onClick={(event) => this.jumpToStep(event, 1)}>
                <li>
                    <span className={"step"}>{labels.step}</span><span className={"step-number"}>1</span>
                    <span className={"step-desc"}>{labels.steps.memberType}</span>
                </li>
            </a>
            <a href="#" className={this.getStepClassName(2)} onClick={(event) => this.jumpToStep(event, 2)}>
                <li>
                    <span className={"step"}>{labels.step}</span><span className={"step-number"}>2</span>
                    <span className={"step-desc"}>{labels.steps.createProfile}</span>
                </li>
            </a>
            <a href="#" className={this.getStepClassName(3)} onClick={(event) => this.jumpToStep(event, 3)}>
                <li>
                    <span className={"step"}>{labels.step}</span><span className={"step-number"}>3</span>
                    <span className={"step-desc"}>{labels.steps.myContactInfo}</span>
                </li>
            </a>
            <a href="#" className={this.getStepClassName(4)} onClick={(event) => this.jumpToStep(event, 4)}>
                <li>
                    <span className={"step"}>{labels.step}</span><span className={"step-number"}>4</span>
                    <span className={"step-desc"}>{labels.steps.myLicense}</span>
                </li>
            </a>
            <a href="#" className={this.getStepClassName(5)} onClick={(event) => this.jumpToStep(event, 5)}>
                <li>
                    <span className={"step"}>{labels.step}</span><span className={"step-number"}>5</span>
                    <span className={"step-desc"}>{labels.steps.myEducation}</span>
                </li>
            </a>
            <a href="#" className={this.getStepClassName(6)} onClick={(event) => this.jumpToStep(event, 6)}>
                <li>
                    <span className={"step"}>{labels.step}</span><span className={"step-number"}>6</span>
                    <span className={"step-desc"}>{labels.steps.payment}</span>
                </li>
            </a>
        </ul>;
    }
}

module.exports = ProgressBar;